// extracted by mini-css-extract-plugin
export var containerStyle = "template_landing_page_report-module--containerStyle--mrLbK";
export var coverImageWrapperStyle = "template_landing_page_report-module--coverImageWrapperStyle--qMMWh";
export var twoColumnLayoutStyle = "template_landing_page_report-module--twoColumnLayoutStyle--8b5vz";
export var wrapperStyle = "template_landing_page_report-module--wrapperStyle--O3rqc";